import $ from 'jquery';
import _ from 'underscore';
import plyr from 'plyr';
import StateManager from '../scuba/StateManager';

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
    $(node).find('.js-player').each(function(i, el) {
        new Player(el);
    });
});


/* --------------------------------------------------

    CLASS

-------------------------------------------------- */

function Player() {
    this.initialize.apply(this, arguments);
}

$.extend(Player.prototype, {

    initialize: function(el) {
      var self = this;
      self.uid = _.uniqueId('scuba-');
      self.$el = $(el);

      self.player = plyr.setup(el);
    },

});



// WEBPACK FOOTER //
// ./scripts/components/Player.js